<template>
  <div class="project-container" ref="projectContainer">
      <div class="project-item" v-for="item in datas" :key="item.id" >
        <img class="project-thumb" v-lazy="item.thumb" >
        <div class="project-info">
          <a :href="item.url?item.url:`javascript:alert('该项目无法通过外网访问')`" :target='item.url?"_blank":"_slef"'><h1>{{ item.name }}</h1></a>
          <div v-for="(desc,index) in item.description" :key="index">
           <span class="description">{{ desc}}</span>
          </div>
          <a class="github" v-if="item.github" :href="item.github?item.github:`javascript:alert('该项目无法通过外网访问')`" target='_blank'>github: {{ item.github}}</a>
        </div>
      </div>
  </div>
</template>

<script>
import { getProject } from "@/api/project"
import fetchData from '@/mixins/fetchData'
import scrollTop from '@/mixins/scrollTop'
export default {
  name: "Project",
  components: {},
  mixins: [fetchData([]),scrollTop('projectContainer')],
  data(){
    return {
    }
  },
  methods:{
    fetchData(){
      return getProject()
    }
  }
};
</script>

<style lang="less">
@import "~@/styles/var.less";
.project-container{
  width: 100%;
  height: 100%;
  scroll-behavior: smooth;
  position: relative;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 20px;
    .project-item{
      transition: .5s;
      display: flex;
      border-radius: 8px;
      padding: 20px;
      &:hover{
        box-shadow: 0 2px 6px 0px rgba(0,0,0,.5);
      }
      .project-thumb{
        width: 200px;
        height: 150px;
        flex: none;
        object-fit: cover;
        border-radius: 5px;
      }
      .project-info{
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        span{
          margin: 5px 0;
        }
        .description{
          // overflow: hidden;
          // text-overflow: ellipsis;
          // display: -webkit-box;
          // -webkit-box-orient: vertical;
          // -webkit-line-clamp: 3;
          line-height: 25px;
          // height: 70px;
        }
        .github{
          text-decoration: revert;
          color: @primary;
        }
      }
    }
  
}
</style>
